import type { Pretensao } from "@/api/db/connection";

export const INTEREST_KEYWORDS = [
	{ keywords: ["lipo", "lipoaspiracao", "lipoescultura"], category: "lipo" },
	{ keywords: ["abdomen", "abdome", "abdominoplastia"], category: "abdomen" },
	{ keywords: ["mama", "protese de mama", "silicone", "mamoplastia"], category: "mama" },
	{ keywords: ["botox", "toxina"], category: "botox" },
	{ keywords: ["preenchimento", "acido hialuronico", "bioestimulador"], category: "preenchimento" },
	{ keywords: ["rino", "nariz", "rinoplastia"], category: "rinoplastia" },
	{ keywords: ["gluteo", "bumbum"], category: "gluteo" },
] satisfies { keywords: string[]; category: Pretensao }[];
